import { initials } from "@/lib/initials"
import type { SearchResultType } from "@/types/v2/search"
import { ResultTypeGlyph, usesAvatar } from "./search-icons"

// Leading swatch shared by the live result rows and the
// cold-start "RECENT" rows (CON-183) — an initials avatar for
// people-ish kinds (contact, conversation), a glyph swatch in
// a cream circle otherwise. Extracted so the two callers
// can't drift on size / palette.

interface ResultLeadingIconProps {
  type: SearchResultType
  // The display title — only used to derive avatar initials.
  title: string
}

export function ResultLeadingIcon({ type, title }: ResultLeadingIconProps) {
  if (usesAvatar(type)) {
    return (
      <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-[#E5DFD3] text-[11px] leading-3.5 font-semibold text-[#1E1B17]">
        {initials(title)}
      </span>
    )
  }
  return (
    <span className="flex size-8 shrink-0 items-center justify-center rounded-full border border-[#F0EDE6] bg-[#FAF7F1]">
      <ResultTypeGlyph type={type} />
    </span>
  )
}
